// ReCharge Subscription Widget - Custom Styling and Price Formatting
(function() {
  'use strict';

  const STYLES = `
    /* Purchase option */
    .rc-purchase-option {
      display: flex;
      flex-direction: column;
      padding: 20px 20px 20px 25px;
      border: none !important;
      background: rgba(226, 227, 227, 0.2);
    }

    .rc-purchase-option[rc-selected] {
      background: rgba(158, 50, 35, 0.1) !important;
    }

    /* Badge */
    .rc-purchase-option .rc-purchase-option__badge {
      position: unset;
      order: 2;
      padding: 0;
      background-color: transparent;
      padding-left: 30px;
      font-family: var(--font-family);
      font-weight: 600;
      font-size: 14px;
      line-height: 171%;
      letter-spacing: -0.02em;
      color: var(--core-palette-red);
    }

    /* Label */
    .rc-purchase-option .rc-purchase-option__label {
      order: 1;
      padding: 0;
    }

    .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices {
      flex-direction: row-reverse;
      gap: 8px !important;
      align-items: center;
    }

    .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__discounted-price"] {
      font-family: var(--font-family) !important;
      font-weight: 600 !important;
      font-size: 22px !important;
      line-height: 127% !important;
      letter-spacing: -0.03em !important;
      text-align: right !important;
      color: var(--core-palette-red) !important;
      display: flex;
      flex-direction: row;
    }

    .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__discounted-price"] .price-dollars {
      font-family: var(--font-family) !important;
      font-weight: 600 !important;
      font-size: 22px !important;
      line-height: 127% !important;
      letter-spacing: -0.03em !important;
      text-align: right !important;
      color: var(--core-palette-red) !important;
    }

    .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__price"] {
      font-family: var(--font-family) !important;
      font-weight: 600 !important;
      font-size: 22px !important;
      line-height: 127% !important;
      letter-spacing: -0.03em !important;
      text-align: right !important;
      color: var(--core-palette-red) !important;
      display: flex;
      flex-direction: row;
    }

    .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__original-price"] .price-dollars {
      font-family: var(--font-family) !important;
      font-weight: 500 !important;
      font-size: 18px !important;
      line-height: 133% !important;
      text-decoration: unset !important;
      text-align: right !important;
      color: var(--core-palette-pantone-cool-gray-7c);
      position: relative !important;
    }

    .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__original-price"] {
      font-family: var(--font-family) !important;
      font-weight: 500 !important;
      font-size: 18px !important;
      line-height: 133% !important;
      text-decoration: unset !important;
      text-align: right !important;
      color: var(--core-palette-pantone-cool-gray-7c);
      position: relative !important;
      display: flex;
      flex-direction: row;
    }

    .rc-purchase-option .rc-purchase-option__label .rc-purchase-option__prices [part="rc-purchase-option__original-price"]:before {
      content: "";
      height: 0.5px;
      width: 100%;
      background-color: var(--core-palette-pantone-cool-gray-7c);
      position: absolute;
      left: 0;
      top: 47%;
      transform: translateY(-50%);
    }

    /* Sub-container */
    .rc-purchase-option .rc-purchase-option__sub-container {
      order: 3;
      padding: 0;
      padding-left: 30px;
      display: flex;
      flex-direction: column-reverse;
      gap: 15px;
    }

    .rc-purchase-option__label {
      padding: 0 !important;
    }

    .rc-purchase-option__selector {
      font-family: var(--second-family);
      font-weight: 500 !important;
      font-size: 20px !important;
      line-height: 150%;
      letter-spacing: -0.06em;
      text-transform: uppercase;
      color: var(--core-palette-black);
      padding: 0 !important;
    }

    rc-selling-plans {
      margin-top: 19px !important;
    }

    .rc-plans-dropdown {
      display: flex !important;
      gap: 10px !important;
    }

    .rc-plans__label {
      font-family: var(--font-family);
      font-weight: 400 !important;
      font-size: 14px !important;
      line-height: 171%;
      letter-spacing: -0.02em;
      color: var(--core-palette-black);
    }

    .rc-benefits__list {
      display: flex !important;
      flex-direction: column !important;
    }

    .rc-benefits__list p {
      margin: 0 !important;
      padding-left: 30px !important;
      font-family: var(--font-family);
      font-weight: 300 !important;
      font-size: 14px !important;
      line-height: 171%;
      letter-spacing: -0.02em !important;
      color: var(--core-palette-black);
      position: relative !important;
      display: flex !important;
      padding-left: 30px !important;
    }

    .rc-benefits__list p:before {
      content: "";
      width: 18px;
      height: 18px;
      position: absolute;
      left: 3px;
      top: 3px;
      background-image: url('data:image/svg+xml;utf8,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 9.57143H9.57143V13H8.42857V9.57143H5V8.42857H8.42857V5H9.57143V8.42857H13V9.57143Z" fill="%23261A1A"/></svg>');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    /* Radio button icons */
    .rc-checked-icon circle {
      stroke-width: 2px !important;
      overflow: visible !important;
    }

    .rc-checked-icon {
      width: 20px !important;
      --rc-widget-brand-color: var(--core-palette-red) !important;
      height: 20px !important;
      stroke-width: 2px !important;
      overflow: visible !important;
    }

    .rc-unchecked-icon {
      width: 20px !important;
      height: 20px !important;
      stroke-width: 2px !important;
      overflow: visible !important;
      --rc-widget-brand-color: var(--core-palette-red) !important;
    }

    .rc-unchecked-icon rect:first-child {
      stroke: var(--core-palette-red) !important;
    }

    .rc-unchecked-icon rect:last-child {
      stroke: none !important;
    }

    /* Hide SVG arrows near dropdown */
    .rc-plans-dropdown svg,
    .rc-plans-dropdown [class*="arrow"],
    .rc-plans-dropdown [class*="chevron"],
    .rc-plans-dropdown [class*="icon"] {
      display: none !important;
      visibility: hidden !important;
    }

    .rc-plans-dropdown__select {
      padding: 4px 10px !important;
      padding-right: 30px !important;
      font-family: var(--font-family);
      font-weight: 400 !important;
      font-size: 14px !important;
      line-height: 100% !important;
      letter-spacing: -0.02em !important;
      color: var(--core-palette-black) !important;
      position: relative !important;
      appearance: none !important;
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
      background-image: url('data:image/svg+xml;utf8,<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="%23000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') !important;
      background-repeat: no-repeat !important;
      background-position: right 10px center !important;
      background-size: 10px 6px !important;
    }

    .rc-plans-dropdown__select:focus-visible {
      outline: 0;
      box-shadow: none !important;
    }

    /* Price cents styling */
    .price-dollars {
      font-size: 22px;
      font-weight: 600;
      vertical-align: baseline;
    }

    .price-cents {
      font-size: 0.6em;
      vertical-align: super;
      margin-top: 2px;
      line-height: 1.4;
    }
  `;

  let styleSheet = null;

  // Create stylesheet once
  function createStyleSheet() {
    if (styleSheet) return styleSheet;
    
    try {
      styleSheet = new CSSStyleSheet();
      styleSheet.replaceSync(STYLES);
      return styleSheet;
    } catch (e) {
      // Fallback for browsers that don't support replaceSync
      return null;
    }
  }

  // Inject styles using adoptedStyleSheets (modern approach)
  function injectStylesModern(shadowRoot) {
    if (!shadowRoot.adoptedStyleSheets) return false;
    
    try {
      const sheet = createStyleSheet();
      if (!sheet) return false;
      
      // Add our stylesheet to the shadow root
      shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];
      return true;
    } catch (e) {
      return false;
    }
  }

  // Inject styles using style element (fallback)
  function injectStylesFallback(shadowRoot) {
    if (shadowRoot.querySelector('style[data-recharge-custom]')) {
      return;
    }

    try {
      const style = document.createElement('style');
      style.setAttribute('data-recharge-custom', 'true');
      style.textContent = STYLES;
      
      // Append to end of shadowRoot (less intrusive than inserting at beginning)
      shadowRoot.appendChild(style);
      return true;
    } catch (e) {
      return false;
    }
  }

  // Format price element using safe DOM manipulation (not innerHTML)
  function formatPriceElement(priceEl) {
    if (!priceEl || !priceEl.isConnected) return false;

    // Get raw text content (including from child nodes if already formatted)
    let currentText = '';
    const existingDollars = priceEl.querySelector('.price-dollars');
    const existingCents = priceEl.querySelector('.price-cents');
    
    if (existingDollars && existingCents) {
      // Already formatted - reconstruct original text to check if changed
      currentText = existingDollars.textContent.trim() + existingCents.textContent.trim();
    } else {
      // Not formatted yet - get text content
      currentText = priceEl.textContent.trim();
    }
    
    if (!currentText) return false;

    // Match price pattern: $XX.XX or $ XX.XX
    const match = currentText.match(/(\$\s*\d+\.)(\d{2})/);
    if (!match) return false;

    const dollarsWithDot = match[1].trim();
    const centsOnly = match[2];

    // Check if already correctly formatted
    if (existingDollars && existingCents) {
      const currentDollars = existingDollars.textContent.trim();
      const currentCents = existingCents.textContent.trim();
      if (currentDollars === dollarsWithDot && currentCents === centsOnly) {
        // Already correctly formatted, skip
        return false;
      }
    }

    // Use safe DOM manipulation instead of innerHTML
    try {
      // Clear existing content safely
      while (priceEl.firstChild) {
        priceEl.removeChild(priceEl.firstChild);
      }

      // Create elements using DOM API
      const dollarsSpan = document.createElement('span');
      dollarsSpan.className = 'price-dollars';
      dollarsSpan.textContent = dollarsWithDot;

      const centsSpan = document.createElement('span');
      centsSpan.className = 'price-cents';
      centsSpan.textContent = centsOnly;

      // Append elements
      priceEl.appendChild(dollarsSpan);
      priceEl.appendChild(centsSpan);

      return true;
    } catch (e) {
      // If error occurs, don't format - widget might be updating
      return false;
    }
  }

  // Format all prices recursively with safety checks
  function formatAllPrices(root) {
    if (!root || !root.isConnected) return;

    const priceSelectors = [
      '[part="rc-purchase-option__discounted-price"]',
      '[part="rc-purchase-option__original-price"]',
      '[part="rc-purchase-option__price"]'
    ];

    priceSelectors.forEach(selector => {
      try {
        const priceElements = root.querySelectorAll(selector);
        priceElements.forEach(el => {
          // Format if element is connected
          if (el && el.isConnected) {
            try {
              formatPriceElement(el);
            } catch (e) {
              // Ignore individual element errors
            }
          }
        });
      } catch (e) {
        // Ignore errors
      }
    });

    // Process nested shadow roots
    try {
      const allElements = root.querySelectorAll('*');
      allElements.forEach(el => {
        if (el.shadowRoot && el.shadowRoot.isConnected) {
          formatAllPrices(el.shadowRoot);
        }
      });
    } catch (e) {
      // Ignore errors
    }
  }

  // Process nested shadow DOMs for styles
  function processNestedShadows(shadowRoot) {
    try {
      const nestedElements = shadowRoot.querySelectorAll('*');
      nestedElements.forEach(el => {
        if (el.shadowRoot && !el.shadowRoot.querySelector('style[data-recharge-custom]')) {
          if (el.tagName.toLowerCase() === 'rc-plans-dropdown') {
            // Special handling for dropdown if needed
            injectStylesFallback(el.shadowRoot);
          } else {
            injectStylesModern(el.shadowRoot) || injectStylesFallback(el.shadowRoot);
          }
        }
      });
    } catch (e) {
      // Ignore errors
    }
  }

  // Initialize widget
  function initWidget(widget, onStylesApplied) {
    if (!widget || !widget.shadowRoot) {
      if (onStylesApplied) onStylesApplied();
      return;
    }

    const shadowRoot = widget.shadowRoot;

    // Wait for widget to be fully rendered before injecting styles
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!widget || !widget.shadowRoot || !shadowRoot.isConnected) {
          if (onStylesApplied) onStylesApplied();
          return;
        }

        // Try modern approach first, fallback to style element
        const stylesInjected = injectStylesModern(shadowRoot) || injectStylesFallback(shadowRoot);
        
        if (stylesInjected) {
          // Process nested shadows after a delay
          setTimeout(() => {
            if (shadowRoot.isConnected) {
              processNestedShadows(shadowRoot);
            }
          }, 100);
        }

        // Format prices after styles are injected and widget is stable
        setTimeout(() => {
          if (shadowRoot.isConnected) {
            formatAllPrices(shadowRoot);
          }
          // Call callback after styles are applied and prices formatted
          if (onStylesApplied) {
            setTimeout(() => {
              onStylesApplied();
            }, 100);
          }
        }, 200);
      });
    });

    // Setup observer for price changes with debouncing
    let formatTimeout = null;
    const observer = new MutationObserver(() => {
      // Debounce formatting to avoid conflicts during widget updates
      if (formatTimeout) {
        clearTimeout(formatTimeout);
      }
      formatTimeout = setTimeout(() => {
        if (shadowRoot.isConnected) {
          formatAllPrices(shadowRoot);
        }
      }, 50);
    });

    observer.observe(shadowRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });

    // Also set up periodic check as backup - more frequent
    const periodicCheck = setInterval(() => {
      if (shadowRoot.isConnected) {
        formatAllPrices(shadowRoot);
      } else {
        clearInterval(periodicCheck);
      }
    }, 300);

    // Setup variant listener when widget is ready
    setTimeout(() => {
      setupVariantListener();
    }, 500);
  }

  // Wait for widget and initialize
  function waitForWidget() {
    const widget = document.querySelector('recharge-subscription-widget');
    
    if (widget && widget.shadowRoot) {
      initWidget(widget);
      return;
    }

    // Watch for widget appearance
    const observer = new MutationObserver(() => {
      const widget = document.querySelector('recharge-subscription-widget');
      if (widget && widget.shadowRoot) {
        observer.disconnect();
        initWidget(widget);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check periodically
    const checkInterval = setInterval(() => {
      const widget = document.querySelector('recharge-subscription-widget');
      if (widget && widget.shadowRoot) {
        clearInterval(checkInterval);
        observer.disconnect();
        initWidget(widget);
      }
    }, 100);

    // Cleanup after 10 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
      observer.disconnect();
    }, 10000);
  }

  // Get current variant ID from variant-selects
  function getCurrentVariantId() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return null;

    const script = variantSelects.querySelector('script[data-selected-variant]');
    if (!script || !script.textContent) return null;

    try {
      const variantData = JSON.parse(script.textContent);
      return variantData && variantData.id ? variantData.id : null;
    } catch (e) {
      return null;
    }
  }

  // Track current variant ID and prevent double rendering
  let currentRenderingVariantId = null;
  let rerenderTimeout = null;

  // Show spinner while widget is loading
  function showSpinner(widgetBlock) {
    // Remove existing spinner if any
    hideSpinner(widgetBlock);

    const spinner = document.createElement('div');
    spinner.className = 'recharge-widget-spinner';
    spinner.innerHTML = `
      <div class="recharge-widget-spinner__loader"></div>
    `;
    widgetBlock.appendChild(spinner);
  }

  // Hide spinner
  function hideSpinner(widgetBlock) {
    const spinner = widgetBlock.querySelector('.recharge-widget-spinner');
    if (spinner) {
      spinner.remove();
    }
  }

  // Inject spinner styles
  function injectSpinnerStyles() {
    if (document.querySelector('style[data-recharge-spinner]')) {
      return;
    }

    const style = document.createElement('style');
    style.setAttribute('data-recharge-spinner', 'true');
    style.textContent = `
      .recharge-widget-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
        width: 100%;
        position: relative;
      }

      .recharge-widget-spinner__loader {
        width: 40px;
        height: 40px;
        border: 4px solid rgba(158, 50, 35, 0.1);
        border-top-color: rgba(158, 50, 35, 1);
        border-radius: 50%;
        animation: recharge-spinner-rotate 0.8s linear infinite;
      }

      @keyframes recharge-spinner-rotate {
        to {
          transform: rotate(360deg);
        }
      }

      .shopify-block.recharge-subscription-widget {
        position: relative;
      }

      .shopify-block.recharge-subscription-widget:has(.recharge-widget-spinner) recharge-subscription-widget {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  // Rerender the entire widget block with new variant ID
  function rerenderWidget(variantId) {
    // Debounce and check if already rendering this variant
    if (rerenderTimeout) {
      clearTimeout(rerenderTimeout);
    }

    rerenderTimeout = setTimeout(() => {
      const widgetBlock = document.querySelector('.shopify-block.recharge-subscription-widget');
      if (!widgetBlock || !variantId) return;

      const widget = widgetBlock.querySelector('recharge-subscription-widget');
      if (!widget) return;

      // Check if we're already rendering this variant or it's already set
      const currentVariantId = widget.getAttribute('default-variant-id');
      if (currentRenderingVariantId === String(variantId) || currentVariantId === String(variantId)) {
        return; // Already rendering or already set
      }

      // Mark that we're rendering this variant
      currentRenderingVariantId = String(variantId);

      // Inject spinner styles if not already injected
      injectSpinnerStyles();

      // Show spinner
      showSpinner(widgetBlock);

      const productId = widget.getAttribute('product-id');
      if (!productId) {
        currentRenderingVariantId = null;
        hideSpinner(widgetBlock);
        return;
      }

      // Find module script
      const moduleScript = widgetBlock.querySelector('script[type="module"]');
      const moduleScriptSrc = moduleScript ? moduleScript.getAttribute('src') : null;

      // Remove old widget
      widget.remove();

      // Create new widget with correct variant ID
      const newWidget = document.createElement('recharge-subscription-widget');
      newWidget.setAttribute('product-id', productId);
      newWidget.setAttribute('default-variant-id', variantId);

      // Insert new widget at the beginning of widgetBlock
      widgetBlock.insertBefore(newWidget, widgetBlock.firstChild);

      // If module script exists, reload it by removing and re-adding
      if (moduleScript && moduleScriptSrc) {
        moduleScript.remove();
        const newModuleScript = document.createElement('script');
        newModuleScript.type = 'module';
        newModuleScript.src = moduleScriptSrc;
        widgetBlock.insertBefore(newModuleScript, newWidget.nextSibling);
      }

      // Reinitialize widget after a delay to let it load
      setTimeout(() => {
        if (newWidget.shadowRoot) {
          initWidget(newWidget, () => {
            // Hide spinner after styles are applied
            hideSpinner(widgetBlock);
            currentRenderingVariantId = null;
          });
        } else {
          waitForShadowRoot(newWidget, (shadowRoot) => {
            initWidget(newWidget, () => {
              // Hide spinner after styles are applied
              hideSpinner(widgetBlock);
              currentRenderingVariantId = null;
            });
          });
        }
      }, 200);
    }, 150); // Debounce 150ms
  }

  // Force format prices in widget
  function forceFormatPrices() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget || !widget.shadowRoot) return;

    // Immediate attempt
    formatAllPrices(widget.shadowRoot);

    // Multiple delayed attempts to catch widget updates
    [50, 100, 200, 300, 500, 800, 1200, 1500, 2000, 3000].forEach(delay => {
      setTimeout(() => {
        if (widget && widget.shadowRoot && widget.shadowRoot.isConnected) {
          formatAllPrices(widget.shadowRoot);
        }
      }, delay);
    });
  }

  // Listen for variant and quantity changes
  function setupVariantListener() {
    // Listen to radio button changes in variant-selects (quantity options)
    // This is the main trigger, others are disabled to avoid double rendering
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      // Listen to radio button changes - this is the primary trigger
      const radioButtons = variantSelects.querySelectorAll('input[type="radio"]');
      radioButtons.forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            // Wait for variant-selects to update the script
            setTimeout(() => {
              const variantId = getCurrentVariantId();
              if (variantId) {
                rerenderWidget(variantId);
              }
            }, 100);
          }
        });
      });

      // Watch for changes in the data-selected-variant script (backup)
      // But only if radio button didn't trigger it
      let scriptChangeTimeout = null;
      const observer = new MutationObserver(() => {
        // Debounce script changes to avoid double rendering
        if (scriptChangeTimeout) {
          clearTimeout(scriptChangeTimeout);
        }
        scriptChangeTimeout = setTimeout(() => {
          const variantId = getCurrentVariantId();
          if (variantId) {
            const widget = document.querySelector('recharge-subscription-widget');
            const currentVariantId = widget ? widget.getAttribute('default-variant-id') : null;
            // Only rerender if variant actually changed
            if (currentVariantId !== String(variantId) && currentRenderingVariantId !== String(variantId)) {
              rerenderWidget(variantId);
            }
          }
        }, 200);
      });

      observer.observe(variantSelects, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    }

    // Listen to variant input changes - only as backup
    const variantInputs = document.querySelectorAll('input[name="id"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        const variantId = input.value;
        if (variantId) {
          const widget = document.querySelector('recharge-subscription-widget');
          const currentVariantId = widget ? widget.getAttribute('default-variant-id') : null;
          // Only rerender if variant actually changed
          if (currentVariantId !== String(variantId) && currentRenderingVariantId !== String(variantId)) {
            rerenderWidget(variantId);
          }
        }
      });
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      waitForWidget();
      setupVariantListener();
    });
  } else {
    waitForWidget();
    setupVariantListener();
  }
})();
